// TODO: @Leo This is a WIP mock up

import { ActiveLimitOrderList } from "module/market/component/MarketDetail/TradingInfo/ActiveOrderList"

import { Badge, Container } from "@chakra-ui/react"
import { MotionHStack } from "component/Motion"
import { SimpleCard } from "component/SimpleCard"
import { TitleText } from "component/Title/TitleText"
import { TitleBarStats } from "component/TitleBarStats"

const PageOrders = () => {
    return (
        <Container maxW="1020px" pt={[0, 0, 8]} pb={40}>
            {/* NOTE: PageTitle */}
            <MotionHStack>
                <TitleText title="Orders" subtitle="All active orders" /> <Badge colorScheme={"yellow"}>WIP</Badge>
            </MotionHStack>

            <SimpleCard mt={6}>
                {/* TODO: make a new component like this to list orders from all markets */}
                <ActiveLimitOrderList />
            </SimpleCard>
            <TitleBarStats />
        </Container>
    )
}

export default PageOrders
